(function () {

  function initSDJournal() {

    const ACCESS_CODE = 'DOWORK30';

    const lockScreen = document.getElementById('sd-lock-screen');
    const journalScreen = document.getElementById('sd-journal-screen');
    const codeInput = document.getElementById('sd-access-code');
    const unlockBtn = document.getElementById('sd-unlock-btn');
    const lockBtn = document.getElementById('sd-lock-btn');
    const error = document.getElementById('sd-code-error');

    if (!lockScreen || !journalScreen) return;

    function openJournal() {
      lockScreen.style.display = 'none';
      journalScreen.style.display = 'block';
    }

    lockScreen.style.display = 'flex';
    journalScreen.style.display = 'none';

    if (unlockBtn && codeInput) {
      unlockBtn.addEventListener('click', function () {

        const entered = codeInput.value.trim().toUpperCase();

        if (entered === ACCESS_CODE) {

          if (error) {
            error.style.display = 'none';
          }

          openJournal();

        } else {

          if (error) {
            error.style.display = 'block';
          }

        }

      });

      codeInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          unlockBtn.click();
        }
      });
    }

    if (lockBtn) {
      lockBtn.addEventListener('click', function () {
        journalScreen.style.display = 'none';
        lockScreen.style.display = 'flex';

        if (codeInput) {
          codeInput.value = '';
        }
      });
    }

    const dayButtons =
      document.querySelectorAll('#sd-journal-app .sd-day-btn');

    const dayPanels =
      document.querySelectorAll('#sd-journal-app .sd-day-panel');

    function showDay(day) {

      dayButtons.forEach(function (button) {
        button.classList.toggle(
          'active',
          button.dataset.day === String(day)
        );
      });

      dayPanels.forEach(function (panel) {
        panel.classList.toggle(
          'active',
          panel.dataset.panel === String(day)
        );
      });

      window.scrollTo({
        top: document.getElementById('sd-journal-app').offsetTop,
        behavior: 'smooth'
      });
    }

    dayButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        showDay(button.dataset.day);
      });
    });

    document
      .querySelectorAll('#sd-journal-app .sd-next-btn')
      .forEach(function (button) {

        button.addEventListener('click', function () {
          showDay(button.dataset.nextDay);
        });

      });

    document
      .querySelectorAll('#sd-journal-app .sd-save')
      .forEach(function (field) {

        const key = field.dataset.key;

        if (!key) return;

        const savedValue =
          localStorage.getItem('sd-journal-' + key);

        if (savedValue !== null) {
          field.value = savedValue;
        }

        field.addEventListener('input', function () {
          localStorage.setItem(
            'sd-journal-' + key,
            field.value
          );
        });

      });

    document
      .querySelectorAll('#sd-journal-app input[type="radio"]')
      .forEach(function (radio) {

        const groupName = radio.name;

        if (!groupName) return;

        const savedValue =
          localStorage.getItem(
            'sd-journal-radio-' + groupName
          );

        if (savedValue === radio.value) {
          radio.checked = true;
        }

        radio.addEventListener('change', function () {
          if (radio.checked) {
            localStorage.setItem(
              'sd-journal-radio-' + groupName,
              radio.value
            );
          }
        });

      });

  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initSDJournal
    );
  } else {
    initSDJournal();
  }

})();